import { RAID_ROLES, type RaidRole } from "@/shared/lib/roles";
import type { SetupPlayer } from "./setup.types";

export type RoleGroupKey = RaidRole | "none";

export type GroupedSetup = {
  // Comp blocks in render order: tank, healer, melee_dps, ranged_dps, then unassigned.
  roleGroups: { key: RoleGroupKey; players: SetupPlayer[] }[];
  bench: SetupPlayer[];
};

// Grouping runs client-side (not trusted from server order for *placement*) so
// optimistic role changes move rows between blocks instantly, before the next poll
// lands. Ordering within a block is the API's (class then name, matching the
// schedule): filter preserves it, and the optimistic patch updates players in place,
// so a moved row keeps its class→name position in its new block.
export function groupPlayers(players: SetupPlayer[]): GroupedSetup {
  const active = players.filter((p) => !p.benched);
  const keys: RoleGroupKey[] = [...RAID_ROLES, "none"];
  const roleGroups = keys
    .map((key) => ({
      key,
      players: active.filter((p) =>
        key === "none" ? !p.raidRole : p.raidRole === key,
      ),
    }))
    // The unassigned block only renders when someone is actually unassigned.
    .filter((g) => g.key !== "none" || g.players.length > 0);
  return { roleGroups, bench: players.filter((p) => p.benched) };
}
